//@flow
import * as React from 'react';
import { Text, Flex, Box } from '@locus-taxy/neo-ui';
import ReactTable from 'react-table';
import withFixedColumns from 'react-table-hoc-fixed-columns';
import pjpPlansTestIds from 'common/tests/masterManagement/pjpPlans.json';

const ReactTableFixedColumns = withFixedColumns(ReactTable);

type Props = {
    tableVisibilityMap: { [table: string]: boolean },
    theme: Object,
    tables: $ReadOnlyArray<Object>,
    t: Function,
    setTableRef: React.RefObject
};

export default class PjpInsightsTable extends React.PureComponent<Props> {
    noDataComponent = () => {
        return null;
    };
    renderTable = table => {
        const { tableVisibilityMap, theme } = this.props;
        const isTableVisible = tableVisibilityMap[table.table];
        const { visible, tableData, tableColumns } = table;
        return (
            <Box className={!isTableVisible ? theme.hideTable : null}>
                <ReactTableFixedColumns
                    NoDataComponent={this.noDataComponent}
                    isPlanTableVisible={visible}
                    minRows={0}
                    data={tableData}
                    columns={tableColumns}
                    showPagination={false}
                    pageSize={tableData.length}
                />
            </Box>
        );
    };

    render() {
        const { setTableRef, tables, t } = this.props;
        return (
            <Flex flexDirection={Flex.Direction.Column} ref={setTableRef}>
                <Text
                    fontSize={4}
                    fontWeight="medium"
                    marginBottom={2}
                    color={'black'}
                    data-test-id={pjpPlansTestIds.insights.table.title}
                >
                    {t('pjpInsights.insightsTable')}
                </Text>
                <Flex flexDirection={Flex.Direction.Column}>
                    {tables.map(tableData => {
                        return this.renderTable(tableData);
                    })}
                </Flex>
            </Flex>
        );
    }
}
